
<script setup>

  import { ref } from 'vue';

  import { TransitionRoot, TransitionChild, Dialog, DialogPanel, DialogTitle } from '@headlessui/vue';

  import { XCircleIcon } from '@heroicons/vue/24/outline';

  import VideoPlayer from '../components/video-player.vue';

  const props = defineProps( { eyebrow: String, heading: String, src: String, tracks: Array } );

  const isOpen = ref( false );

  const promise = ref( null );

  let promiseResolve, promiseReject;

  function open() {
    
    isOpen.value = true;

    return promise.value = new Promise( ( resolve, reject ) => {

      promiseResolve = resolve;

      promiseReject = reject;

    } );

  }

  function close() {
    
    isOpen.value = false;

    if ( promiseResolve ) promiseResolve();

  }

  defineExpose( { open, close } );

</script>

<template>

  <TransitionRoot appear :show="isOpen" as="template">

    <Dialog as="div" @close="close" class="relative z-20">

      <TransitionChild

        as="template"

        enter="transition-opacity duration-300 ease-out"

        enter-from="opacity-0"

        enter-to="opacity-100"

        leave="transition-opacity duration-200 ease-in"

        leave-from="opacity-100"

        leave-to="opacity-0">

        <div class="fixed inset-0 bg-black bg-opacity-75" />

      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">

        <div class="flex min-h-full items-center justify-center p-6 md:p-12 lg:px-24 drop-shadow-[0_0_15px_rgba(0,0,0,1)]">

          <TransitionChild

            as="template"

            enter="transition transform duration-300 ease-out"

            enter-from="opacity-0 scale-95"

            enter-to="opacity-100 scale-100"

            leave="transition transform duration-200 ease-in"

            leave-from="opacity-100 scale-100"

            leave-to="opacity-0 scale-95">

            <DialogPanel class="w-full max-w-6xl overflow-hidden">

              <DialogTitle class="flex items-center text-white">

                <div class="grow">

                  <div class="text-xl tracking-narrow font-semibold uppercase">{{ eyebrow }}</div>

                  <div class="text-3xl md:text-5xl font-heading uppercase">{{ heading }}</div>

                </div>

                <button type="button" class="flex items-center justify-center w-14 h-14" @click="close">

                  <XCircleIcon class="w-12" />
                
                </button>

              </DialogTitle>

              <VideoPlayer class="mt-4" :src="src" :tracks="tracks" :autoplay="true" @ended="close" />

            </DialogPanel>

          </TransitionChild>

        </div>

      </div>

    </Dialog>

  </TransitionRoot>

</template>
